import { useState, FC } from 'react';
import { useAuth } from '../contexts/AuthContext';
import config from '../config';
import styled from 'styled-components';
import { Skeleton } from './Skeleton';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 6rem 0rem;
  text-align: center;
  width: 100%;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  margin: 0;
  border: 1px solid #3662FF;
  border-radius: 4px 4px 0 0;
  background-color: #FCF9F3;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1rem;
  resize: vertical;
  &:focus {
    outline: none;
  }
`;

const Button = styled.button`

`;

const SecretUrl = styled.div`
  margin: 2rem 0;
  border-radius: 4px;
`;

export const CreateSecret: FC = () => {
  const { isAuthenticated, login } = useAuth();

  if (!isAuthenticated) {
    login();
  }

  const [secret, setSecret] = useState('');
  const [secretId, setSecretId] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const { token, logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const createSecret = async () => {
    if (!secret) return;
    setIsLoading(true);

    try {
      const response = await fetch(`${config.apiUrl}/secrets`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ secret }),
      });

      if (response.status === 401) {
        logout();
        return;
      }

      const { id } = await response.json();
      setSecretId(id);
    } catch (error) {
      // Handle error
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = async () => {
    const secretUrl = `${config.secretsBaseUrl}/secrets/${secretId}`;
    try {
      await navigator.clipboard.writeText(secretUrl);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
    }
  };

  return (
    <Container>
      <div>
        <TextArea
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
          placeholder="Enter your secret here..."
          disabled={isLoading}
        />
        <Button className="no-margin" onClick={createSecret} disabled={isLoading}>
          Create One-Time Secret Link
        </Button>
      </div>
      {isLoading ? (
        <SecretUrl>
          <Skeleton.Text height="24px" />
          <Skeleton.Button />
        </SecretUrl>
      ) : secretId && (
        <SecretUrl>
          <p className='secret-url'>{config.secretsBaseUrl}/secrets/{secretId}</p>
          <Button onClick={copyToClipboard}>
            Copy URL
          </Button>
          <div className="copy-success">
            {copySuccess && <span style={{ marginLeft: '8px' }}>{copySuccess}</span>}
          </div>
        </SecretUrl>
      )}
    </Container>
  );
};
